const ACTIVE_APP_KEY = 'activeApp';

const VALID_APPS = ['crm', 'hubup', 'web-creator', 'enterprise'];

/** Profils d'accès : dual = choix modal, hubup_only = onglets HubUP, crm_only = comportement CRM actuel */
export function computeAccessProfile(user) {
  if (!user) return { kind: 'unknown' };
  const isAdmin = user.permission === 'admin';
  const hubup = user.hubup === true;
  const crm = user.crm === true;
  if (isAdmin || (hubup && crm)) {
    return { kind: 'dual' };
  }
  if (hubup && !crm) {
    return { kind: 'hubup_only' };
  }
  return { kind: 'crm_only' };
}

export function canOpenEnterpriseApp(user) {
  if (!user) return false;
  if (user.permission === 'admin') return true;
  return user.enterpriseAccess?.canOpenEnterpriseApp === true;
}

/** Applications accessibles (Just One Page pour tous). */
export function getAvailableApps(user) {
  if (!user) return [];
  const profile = computeAccessProfile(user);
  const apps = [];
  if (profile.kind === 'dual') {
    apps.push('crm', 'hubup', 'web-creator');
  } else if (profile.kind === 'hubup_only') {
    apps.push('hubup', 'web-creator');
  } else {
    apps.push('crm', 'web-creator');
  }
  if (canOpenEnterpriseApp(user) && !apps.includes('enterprise')) {
    apps.push('enterprise');
  }
  return apps;
}

export function hasMultipleApps(user) {
  return getAvailableApps(user).length > 1;
}

export function getDefaultCrmPath(user) {
  if (!user) return '/login';
  return '/call-performance-analytics';
}

export function getDefaultEnterprisePath() {
  return '/enterprise-manage';
}

export function getDefaultWebCreatorPath() {
  return '/web-creator';
}

export function readStoredActiveApp() {
  try {
    const v = sessionStorage.getItem(ACTIVE_APP_KEY);
    if (VALID_APPS.includes(v)) return v;
  } catch {
    /* ignore */
  }
  return null;
}

export function writeStoredActiveApp(mode) {
  try {
    if (VALID_APPS.includes(mode)) {
      sessionStorage.setItem(ACTIVE_APP_KEY, mode);
    }
  } catch {
    /* ignore */
  }
}

export function clearStoredActiveApp() {
  try {
    sessionStorage.removeItem(ACTIVE_APP_KEY);
  } catch {
    /* ignore */
  }
}
